var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRozielogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "url(#paint0_linear_174_3360)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_174_3360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8896 43.8243C50.2881 45.9797 48.3081 47.5637 45.9622 47.5637C45.5412 47.5637 45.1301 47.5135 44.7392 47.4133C44.1226 47.288 43.5061 47.0173 42.9096 46.5511C42.4234 46.1852 42.0023 45.7391 41.6715 45.2278C41.5813 45.1025 41.491 44.9722 41.4008 44.8318L38.6188 40.4358C37.07 37.9295 35.3256 36.7716 33.5461 36.3506C32.0424 36.902 30.1727 37.1225 27.877 36.7817L33.476 46.3306C38.1477 54.1552 50.684 52.912 50.9998 43.5536C50.9698 43.6438 50.9297 43.7341 50.8896 43.8243Z",
    fill: "url(#paint1_linear_174_3360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0137 25.5537V38.7869C19.0137 43.7242 23.8357 45.6641 26.6728 45.6641V24.1402C25.8508 23.8495 24.9586 23.6941 24.0212 23.6941C22.1716 23.6941 20.2869 24.4009 19.0137 25.5537Z",
    fill: "url(#paint2_linear_174_3360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5514 36.3509C36.99 35.0928 38.4838 32.0702 38.5389 29.8747C38.6993 23.6541 34.0828 20 28.5088 20C24.574 20 20.6842 22.2506 19.0201 25.5389L19.015 25.5439C19.01 25.5489 19.005 25.5589 19 25.5639C19.005 25.5589 19.01 25.5589 19.015 25.5539C20.2882 24.401 22.1729 23.6942 24.0276 23.6942C24.9649 23.6942 25.8572 23.8496 26.6792 24.1404C29.3359 25.0777 31.2256 27.4537 31.1955 30.8672C31.1755 33.3234 29.767 35.4888 27.8822 36.782C30.178 37.1229 32.0477 36.9023 33.5514 36.3509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9629 45.731C47.7774 45.731 49.2461 44.2623 49.2461 42.4478C49.2461 40.6332 47.7774 39.1646 45.9629 39.1646C44.1484 39.1646 42.6797 40.6332 42.6797 42.4478C42.6797 44.2623 44.1484 45.731 45.9629 45.731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_174_3360",
    x: 16,
    y: 18,
    width: 38,
    height: 37.4736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_174_3360"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_174_3360",
    result: "effect2_dropShadow_174_3360"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_174_3360",
    result: "effect3_dropShadow_174_3360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_174_3360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_174_3360",
    x1: -17.325,
    y1: 85.575,
    x2: 74.025,
    y2: -6.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#834C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_174_3360",
    x1: 37.8032,
    y1: 47.7526,
    x2: 40.8558,
    y2: 34.2249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#7F7D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#3A3738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_174_3360",
    x1: 24.8495,
    y1: 40.7306,
    x2: 19.2046,
    y2: 15.7997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#817F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3C393A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#231F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRozielogoMobile);
export default __webpack_public_path__ + "static/media/rozielogo_mobile.e7ca03595f6629094c745b0a4320bfd4.svg";
export { ForwardRef as ReactComponent };